<template>
    <div>
        <v-row>
            <v-col cols="8">
                <v-card>
                    <v-card-title>
                        نرخ خرید و تحویل بار
                    </v-card-title>
                    <v-card-text>
                        <div class="container">
                            <div class="row ">
                                <v-data-table
                                    dense
                                    height="400"
                                    fixed-header
                                    hide-default-footer
                                    disable-pagination
                                    multi-sort
                                        class="margin-auto table-bordered"
                                        :headers="headers"
                                        :items="items"
                                >
                                    <template v-slot:item.operation="{ item }">

                                        <v-btn title="ویرایش" @click="edit_item(item)" outlined small color="warning">
                                            <v-icon small color="warning">mdi-pencil</v-icon>
                                        </v-btn>
                                        <v-btn title="حذف"  @click="delete_item_dialog(item)" outlined small color="error">
                                            <v-icon small color="error">mdi-delete</v-icon>
                                        </v-btn>
                                    </template>
                                    <template v-slot:item.buy_price="{ item }">
                                       <p>{{get_currency(item.buy_price)}}</p>
                                    </template>
                                    <template v-slot:item.delivery_price="{ item }">
                                       <p>{{get_currency(item.delivery_price)}}</p>
                                    </template>

                                </v-data-table>
                            </div>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="4">
                <v-card>
                    <v-card-title>
                        افزودن نرخ خرید و تحویل بار
                    </v-card-title>
                    <v-card-text>

                            <v-row form class="form-group">
                                <label >
                                    مبدا بارگیری
                                </label>
                                <div dir="rtl">
                                    <treeselect
                                            :matchKeys="['code']"
                                            v-model="model.selected_origin_load"
                                            :cacheOptions="false"
                                            :options="origin_loads"
                                            placeholder="جستجو مبدا بارگیری"
                                            :normalizer="normalizer_origin"
                                    />
                                </div>
                            </v-row>

                            <v-row form class="form-group">
                                <label >
                                    محل تخلیه
                                </label>
                                <div dir="rtl">
                                    <treeselect
                                            :matchKeys="['code']"
                                            v-model="model.selected_discharge_place"
                                            :cacheOptions="false"
                                            :options="discharge_places"
                                            placeholder="جستجو محل تخلیه"
                                            :normalizer="normalizer_discharge_place"
                                    />
                                </div>
                            </v-row>
                            <v-row form class="form-group">
                                <label >
                                    نوع جنس
                                </label>
                                <div dir="rtl">
                                    <treeselect
                                            :matchKeys="['code']"
                                            v-model="model.selected_load_type"
                                            :cacheOptions="false"
                                            :options="load_types"
                                            placeholder="جستجو نوع جنس"
                                            :normalizer="normalizer_load_type"
                                    />
                                </div>
                            </v-row>
<br>
                  <v-row>
                      <v-col cols="7">
                          <v-text-field
                              dense
                              v-model="model.buy_price"
                                  id="buy_price"
                                  @keypress="isNumber"
                                  suffix="تن/ریال"
                                  v-on:keyup.enter="another_focus('buy_tax')"
                                  label="قیمت خرید"/>
                      </v-col>
                      <v-col cols="5">
                          <v-text-field
                                  id="buy_tax"
                                  dense
                                  v-model="model.buy_tax"
                                  @keypress="isNumber"
                                  suffix="درصد"
                                  v-on:keyup.enter="another_focus('delivery_price')"
                                  label="مالیات خرید"/>
                      </v-col>
                  </v-row>
                      <v-row>
                      <v-col cols="7">
                          <v-text-field
                                  id="delivery_price"
                                  suffix="تن/ریال"
                                  v-model="model.delivery_price"
                                  dense
                                  @keypress="isNumber"
                                  v-on:keyup.enter="another_focus('delivery_tax')"
                                  label="قیمت تحویل"/>
                      </v-col>
                      <v-col cols="5">
                          <v-text-field
                                  id="delivery_tax"
                                  dense
                                  v-model="model.delivery_tax"
                                  @keypress="isNumber"
                                  suffix="درصد"
                                  v-on:keyup.enter="another_focus('add_price_buy_delivery')"
                                  label="مالیات تحویل"/>
                      </v-col>
                  </v-row>






                    </v-card-text>
                    <v-card-actions>
                        <v-btn v-if="status_form==0" color="success" id="add_price_buy_delivery" @click="insert_data()">ثبت</v-btn>
                        <v-btn v-if="status_form!=0" color="warning" id="add_price_buy_delivery" @click="insert_data()">ویرایش
                        </v-btn>
                        <v-btn color="warning" @click="reset_form()">انصراف</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>
<script>
    import Vue from 'vue'
    import { bus } from '../../main'
    import Treeselect from '@riophae/vue-treeselect'
    // import the styles
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'

    export default {
        name: 'OriginDownload',
        components: {Treeselect},
        data () {
            return {
                confirm_delete_name: 'confirm_delete' + new Date().getTime() + '_' + this.$vnode.tag,
                items: [],
                status_form: 0,
                origin_loads:[],
                discharge_places:[],
                load_types:[],
                model: {
                    selected_origin_load:null,
                    selected_discharge_place:null,
                    selected_load_type:null,
                    buy_price:'',
                    buy_tax:'',
                    delivery_price:'',
                    delivery_tax:'',

                },
                headers: [
                    {
                        text: 'مبدا بارگیری',
                        value: 'origin_load'
                    },
                    {
                        text: 'محل تخلیه',
                        value: 'discharge_place'
                    },
                    {
                        text: 'نوع جنس بار',
                        value: 'load_type'
                    },
                    {
                        text: 'مبلغ خرید',
                        value: 'buy_price'
                    },
                    {
                        text: 'مبلغ تحویل',
                        value: 'delivery_price'
                    },
                    {
                        text: '% مالیات خرید',
                        value: 'buy_tax'
                    },
                    {
                        text: '% مالیات تحویل',
                        value: 'delivery_tax'
                    },
                    {
                        text: 'عملیات',
                        value: 'operation'
                    }
                ],



                normalizer_origin(node) {
                    return {
                        id: node.id,
                        label: node.code+" - "+node.name,
                        code:node.code,

                    }
                },
                normalizer_load_type(node) {
                    return {
                        id: node.id,
                        label: node.code+" - "+node.name,
                        code:node.code,

                    }
                },
                normalizer_discharge_place(node) {
                    return {
                        id: node.id,
                        label: node.code+" - "+node.name,
                        code:node.code,

                    }
                },
            }
        },
        mounted () {
            this.get_data()
            this.get_origin_downloads()
            this.get_load_types()
            this.get_discharge_places()
            bus.$on(this.confirm_delete_name, (data) => {
                // alert(data);
                if (data == 'true') {
                    this.delete_item()

                } else {
                    this.status_form = 0
                }
            })
        },
        methods: {
            reset_form () {
                this.model = {
                    selected_origin_load:null,
                    selected_discharge_place:null,
                    selected_load_type:null,
                    buy_price:'',
                    buy_tax:'',
                    delivery_price:'',
                    delivery_tax:'',
                }
                this.status_form = 0
            },
            edit_item (item) {
                this.model = item
                this.model.selected_origin_load = parseInt(item.origin_load_id);
                this.model.selected_load_type = parseInt(item.load_type_id);
                this.model.selected_discharge_place = parseInt(item.discharge_place_id);
                this.status_form = item.id
            },
            get_data () {
                var self = this
                const formData = new FormData()
                // formData.append('id', this.selected_province);
                this.axios.post('/api/price_buy_delivery/select', formData, {}).then(function (response) {

                    // items = content_cats.orders;
                    if (response.data.error == 0) {

                        self.items = response.data.data

                    } else {
                        self.$root.modal_component.show_danger_modal('خطا', response.data.msg)

                    }

                }).catch(function (error) {
                    self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')

                    console.log(error)
                })

            },
            insert_data () {
                var self = this
                const formData = new FormData()
                // formData.append('id', this.selected_province);
                var url = '/api/price_buy_delivery/insert'
                if (this.status_form != 0) {
                    url = '/api/price_buy_delivery/update'
                    formData.append('id', this.status_form)
                }
                formData.append('origin_load_id', this.model.selected_origin_load)
                formData.append('discharge_place_id', this.model.selected_discharge_place)
                formData.append('load_type_id', this.model.selected_load_type)
                formData.append('buy_price', this.model.buy_price)
                formData.append('buy_tax', this.model.buy_tax)
                formData.append('delivery_price', this.model.delivery_price)
                formData.append('delivery_tax', this.model.delivery_tax)

                this.axios.post(url, formData, {}).then(function (response) {
                    self.$root.modal_component.show_api_response_modals(response)

                    // items = content_cats.orders;
                    if (response.data.error == 0) {
                        self.reset_form()
                        self.get_data()
                    }
                }).catch(function (error) {
                    self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')

                    console.log(error)
                })

            },
            delete_item_dialog (item) {
                this.$root.modal_component.show_confirm_modal('هشدار', 'آیا مایل به حذف این ردیف هستید؟', ['تایید'], this.confirm_delete_name)
                this.status_form = item.id

            },
            delete_item () {
                const self = this
                const formData = new FormData()
                const url = '/api/price_buy_delivery/delete'
                formData.append('id', this.status_form)

                this.axios.post(url, formData, {}).then((res) => {

                    self.$root.modal_component.show_api_response_modals(res)
                    self.status_form = 0

                    self.get_data()

                })
                    .catch(function (error) {
                        console.log(error)
                    })
// this.get_categories();
                // this.$router.push({ path: '/posts/'});
            },
            get_origin_downloads () {
                var self = this
                const formData = new FormData()
                // formData.append('id', this.selected_province);
                this.axios.post('/api/origin/select', formData, {}).then(function (response) {

                    // items = content_cats.orders;
                    if (response.data.error == 0) {

                        self.origin_loads = response.data.data

                    } else {
                        self.$root.modal_component.show_danger_modal('خطا', response.data.msg)

                    }

                }).catch(function (error) {
                    self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')

                    console.log(error)
                })

            },
            get_load_types () {
                var self = this
                const formData = new FormData()
                // formData.append('id', this.selected_province);
                this.axios.post('/api/load_type/select', formData, {}).then(function (response) {

                    // items = content_cats.orders;
                    if (response.data.error == 0) {

                        self.load_types = response.data.data

                    } else {
                        self.$root.modal_component.show_danger_modal('خطا', response.data.msg)

                    }

                }).catch(function (error) {
                    console.log(error)
                })

            },
            get_discharge_places () {
                var self = this
                const formData = new FormData()
                // formData.append('id', this.selected_province);
                this.axios.post('/api/discharge_places/select', formData, {}).then(function (response) {

                    // items = content_cats.orders;
                    if (response.data.error == 0) {

                        self.discharge_places = response.data.data

                    } else {
                        self.$root.modal_component.show_danger_modal('خطا', response.data.msg)

                    }

                }).catch(function (error) {
                    self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')

                    console.log(error)
                })

            },

        }
    }
</script>
